import { AfterViewInit, Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {  Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { HttpService } from '../../services/main_local.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

})
export class LoginComponent implements OnInit,AfterViewInit {
  loginForm!: FormGroup;
  mobileNumber:any;
  countryCode:any = '+678';
  authToken: any = null; 
  isHandset$: Observable<boolean> = this.sharedService.isHandset()
  role:any;


  constructor(
     private fb: FormBuilder,
     private router : Router,
     private spinner: NgxSpinnerService,
     private sharedService : SharedService,
     private snackBar:MatSnackBar,
     private route : ActivatedRoute,
     private httpService : HttpService) { 

    }

  hide = true;
  ngOnInit(): void {
    this.spinner.show();
    this.loginForm = this.fb.group({
      mobileNumber: ['',[Validators.required,Validators.minLength(5),Validators.maxLength(10)]],
    });
    let mdr_token = localStorage.getItem("mdr-token")
    let auth_token =  localStorage.getItem("mdr-token-auth")
    this.role = localStorage.getItem("display-role");
    if(mdr_token && auth_token) {
      if(this.role == 'Analyst' || this.role == 'Admin') {
        this.router.navigate(['/main/users/list']);
      } else {
        this.router.navigate(['main/patients/patientslist'])
      }
    }
    this.spinner.hide();
  }

  ngAfterViewInit(): void {
    console.log("login");
  }

  clear(){
    this.mobileNumber = null;
  }

  keyPressNumber(event:any) {
    let test = String.fromCharCode(event.keyCode);
    if (/\d/.test(test)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  onSubmit(){
    this.spinner.show();
    const body: any = {
      "mobileNumber": this.mobileNumber,
      "isdCode": this.countryCode,
      "isMobile": false,
      "forgotPass": false
    }
    this.httpService.postRequestCall('auth/verifyUser', body, this.authToken, {}).subscribe({
      next: (value)=>{
        this.spinner.hide();
        let data:any = value;
        this.snackBar.open((data?.message), '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        if(data.data.otpPage == true){
        this.router.navigate(['otpverify'],{relativeTo:this.route,queryParams:{mob:this.loginForm.get('mobileNumber')?.value}});
        } else {
          this.router.navigate(['password'],{relativeTo:this.route,queryParams:{mob:this.loginForm.get('mobileNumber')?.value}});
        }
      },
      error:(err)=>{
        this.errorStatus(err);
      }
    })
  }

  forgotPassword(){
    this.router.navigate(['forgot-password'])
  }

  errorStatus(error:any){
    this.spinner.hide();
    let msg;
    if(error.error.message) {
      msg = error.error.message;
    } else {
      msg = 'Internal server error'
    }
    this.snackBar.open(msg, '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }
}
